import { makeStyles } from '@material-ui/core'

export const useStyles = makeStyles((theme) => ({
  propertiesContainer: {
    width: '100%',
    height: '100%',
    position: 'relative',
    boxSizing: 'border-box',
    display: 'flex',
    flexDirection: 'column',
    gap: 16
  },

  loadingContainer: {
    position: 'absolute',
    inset: 0,
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center'
  },

  reproductionInfoContainer: {
    marginTop: 16
  },

  pregnancyDiagnosisHeader: {
    width: '100%',
    display: 'inline-flex',
    justifyContent: 'space-between',

    [theme.breakpoints.down('sm')]: {
      flexDirection: 'column',
      alignItems: 'flex-start'
    }
  },

  pregnancyDiagnosisTitle: {
    color: theme.palette.primary.main,
    fontSize: theme.app.typography.subTitle.fontSize,
    fontWeight: theme.app.typography.subTitle.fontWeight
  },

  title: {
    margin: 0,
    color: theme.palette.primary.main,
    fontSize: 18,
    fontWeight: 500,
    marginBottom: 16
  },

  section: {
    border: '1px solid ' + theme.palette.divider,
    borderRadius: 8,
    padding: 16,
    backgroundColor: theme.palette.background.default
  },

  reproductionDiagnosisLayout: {
    display: 'flex',
    opacity: 0.5,
    pointerEvents: 'none',
    gap: 16,
    alignItems: 'flex-start',

    [theme.breakpoints.down('sm')]: {
      flexDirection: 'column'
    }
  },

  reproductionDiagnosisLayoutActive: {
    opacity: 1,
    pointerEvents: 'auto'
  },

  reproductionSection: {
    width: '60%',

    [theme.breakpoints.down('sm')]: {
      width: '100%'
    }
  },

  diagnosisSection: {
    width: '40%',

    [theme.breakpoints.down('sm')]: {
      width: '100%'
    }
  },

  sectionHeader: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    gap: 12,
    marginTop: 16,
    marginBottom: 16,

    [theme.breakpoints.down('sm')]: {
      flexDirection: 'column',
      alignItems: 'flex-start'
    }
  },

  sectionTitle: {
    margin: 0,
    color: theme.palette.primary.main,
    fontSize: 18,
    fontWeight: 500
  },

  infoGrid: {
    display: 'grid',
    gridTemplateColumns: 'repeat(2, minmax(0, 1fr))',
    gap: 16,

    [theme.breakpoints.down('sm')]: {
      gridTemplateColumns: '1fr'
    }
  },

  singleColumnGrid: {
    gridTemplateColumns: '1fr !important'
  },

  formControl: {
    marginBottom: 16
  },

  checkboxContainer: {
    marginTop: 16,
    marginBottom: 8
  },

  diagnosisInfoContainer: {
    display: 'flex',
    flexDirection: 'column',
    gap: 16
  },

  radioGroupInline: {
    display: 'flex',
    gap: 24
  },

  buttonWrapper: {
    width: 'auto',
    display: 'flex',
    padding: '8px 16px 8px 12px',
    gap: '8px'
  },

  buttonOutlined: {
    backgroundColor: 'transparent',
    border: `1px solid ${theme.palette.primary.main}`,
    color: theme.palette.primary.main
  },

  secondaryOutlinedField: {
    backgroundColor: 'transparent',
    border: `1px solid ${theme.palette.divider}`,
    color: theme.palette.text.secondary,
    cursor: 'default',
    pointerEvents: 'none'
  },

  actionsContainer: {
    display: 'flex',
    justifyContent: 'flex-end',
    gap: 10,
    marginTop: 12,

    [theme.breakpoints.down('sm')]: {
      width: '100%',
      flexDirection: 'column'
    }
  },

  pendingDiagnosisContainer: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    justifyContent: 'center',
    gap: 16,
    padding: '32px 16px',
    textAlign: 'center'
  },

  pendingDiagnosisContent: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    gap: 8
  },

  pendingDiagnosisIcon: {
    fontSize: 48,
    color: theme.palette.text.secondary,
    opacity: 0.5
  },

  pendingDiagnosisText: {
    fontSize: 14,
    color: theme.palette.text.secondary,
    fontWeight: 500
  },

  warningSection: {
    border: `1px solid ${theme.palette.warning.main}`,
    borderRadius: 8,
    padding: 16,
    backgroundColor: theme.palette.warning.light,
    display: 'flex',
    alignItems: 'center',
    gap: 12,
    marginBottom: 16
  },

  warningIcon: {
    color: theme.palette.warning.main,
    fontSize: 24
  },

  warningText: {
    color: theme.palette.text.primary,
    fontSize: 14,
    fontWeight: 500
  },

  customButtonWrapper: {
    width: 'auto'
  },

  filterContainer: {
    '& .containerButtons': {
      display: 'flex',
      gap: '20px',
      marginBottom: '20px'
    }
  },

  pregnancyDiagnosisContainer: {
    padding: '16px 16px 16px 0',
    display: 'flex',
    flexDirection: 'row'
  },

  pregnancyDiagnosisHeaderContent: {
    width: '100%',
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',

    [theme.breakpoints.down('sm')]: {
      flexDirection: 'column',
      alignItems: 'start'
    }
  },

  pregnancyDiagnosisHeaderBtnContainer: {
    display: 'flex',
    alignItems: 'center',

    '& :nth-child(2)': {
      width: 139,
      marginLeft: 16
    },

    [theme.breakpoints.down('sm')]: {
      padding: '16px 0',
      flexWrap: 'wrap'
    }
  },

  pregnancyDiagnosisHeaderBtn: {
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',
    justifyContent: 'center',
    textAlign: 'center',
    backgroundColor: 'transparent',
    width: 118,
    height: 40,
    borderWidth: 1,
    borderRadius: 6,
    borderColor: theme.palette.primary.main,
    fontWeight: 800,
    color: theme.palette.primary.main
  },

  pregnancyDiagnosisContainerContent: {
    width: '100%',
    overflow: 'hidden',
    display: 'flex',

    '&>*:nth-child(2)': {
      marginRight: 24,
      marginLeft: 24
    },

    '@media (max-width:767px)': {
      overflowX: 'scroll'
    }
  },

  pregnancyDiagnosisStatusPending: {
    padding: 10,
    backgroundColor: '#5778EC',
    borderRadius: 4,

    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center'
  },

  pregnancyDiagnosisStatusDone: {
    maxWidth: 91,
    padding: 10,
    backgroundColor: '#4BC599',
    borderRadius: 4,

    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center'
  },

  pregnancyDiagnosisStatusText: {
    width: 110,
    color: theme.app.colors.text.light
  },

  pregnancyDiagnosisContainerContentData: {
    height: '100%',
    position: 'relative',
    paddingRight: 16
  },

  pregnancyDiagnosisContainerContentDataNew: {
    height: '100%',
    position: 'relative',
    paddingRight: 16,
    display: 'flex',
    flexDirection: 'column',
    gap: 16
  },

  infoItem: {
    display: 'flex',
    flexDirection: 'column',
    gap: 6
  },

  infoLabel: {
    fontSize: theme.app.typography.small.fontSize,
    color: theme.app.colors.text.primary
  },

  infoValue: {
    fontSize: theme.app.typography.body.fontSize,
    fontWeight: 500,
    color: theme.app.colors.text.primary
  },

  radioGroup: {
    display: 'flex',
    gap: 24,
    alignItems: 'center',

    [theme.breakpoints.down('sm')]: {
      flexDirection: 'column',
      alignItems: 'flex-start',
      gap: 12
    }
  },

  pregnancyDiagnosisDivider: {
    width: 'calc(100% - 293px)',

    [theme.breakpoints.down('sm')]: {
      width: '100%'
    }
  },

  pregnancyDiagnosisTableActions: {
    width: '100%',
    display: 'flex',
    height: 5,
    '& img': {
      cursor: 'pointer'
    },
    [theme.breakpoints.up('md')]: {
      justifyContent: 'space-around'
    }
  },

  pregnancyDiagnosisSubTitle: {
    color: theme.palette.primary.main,
    fontSize: 18,
    fontWeight: 500
  },

  pregnancyDiagnosisDividerSubTitle: {
    height: 1,
    width: '100%',
    backgroundColor: theme.app.colors.border.light
  },

  pregnancyDiagnosisButtonContainer: {
    marginLeft: 'auto',
    width: '100%',
    '& h1': {
      margin: '0 16px 0 0',
      cursor: 'pointer'
    },
    '@media (min-width:356px)': {
      width: 'unset',
      '& button': {
        width: 146,
        margin: '0 16px 0 0',
        '& img': {
          marginRight: 8
        }
      }
    }
  },

  pregnancyDiagnosisPopup: {
    '& .popup__box': {
      height: 660,
      maxWidth: 1113
    }
  },

  errorMessage: {
    color: theme.palette.primary.main,
    fontFamily: theme.app.typography.fontFamily.secondary,
    fontSize: 14,
    fontWeight: theme.app.typography.paragraph.fontWeight,
    lineHeight: '20px'
  }
}))
